import { useId } from "react";

export const StampSeal = ({ place, year, dim, className }) => {
  const uid = useId();
  const ink = dim ? "#6B7280" : "#D4AF37";
  return (
    <svg viewBox="0 0 200 200" className={className || "w-full h-full"} aria-hidden="true">
      <circle cx="100" cy="100" r="92" fill="none" stroke={ink} strokeWidth="5" strokeDasharray="4 7" />
      <circle cx="100" cy="100" r="72" fill="none" stroke={ink} strokeWidth="2.5" />
      <path id={`${uid}t`} d="M 32 100 A 68 68 0 0 1 168 100" fill="none" />
      <text fill={ink} fontSize="19" fontWeight="800" letterSpacing="3">
        <textPath href={`#${uid}t`} startOffset="50%" textAnchor="middle">{place}</textPath>
      </text>
      <text x="100" y="115" textAnchor="middle" fill={ink} fontSize="36" fontWeight="900" letterSpacing="2">{year}</text>
      <path id={`${uid}b`} d="M 40 112 A 64 64 0 0 0 160 112" fill="none" />
      <text fill={ink} fontSize="11" fontWeight="700" letterSpacing="3">
        <textPath href={`#${uid}b`} startOffset="50%" textAnchor="middle">URBAN PASSPORT</textPath>
      </text>
    </svg>
  );
};
